import { useRef, useEffect } from 'react';
import enableRipple from './enableRipple';
/**
 * 使用水波纹效果
 *
 * @param config 配置
 */
export default function useRipple(config, disabled) {
    if (config === void 0) { config = {}; }
    var domRef = useRef();
    var rippleRef = useRef();
    useEffect(function () {
        if (domRef.current && !disabled) {
            rippleRef.current = enableRipple(domRef.current, config);
            if (config.position) {
                domRef.current.style.position = config.position;
            }
            else if (domRef.current.style.position === 'static') {
                domRef.current.style.position = 'relative';
            }
        }
        return function () {
            if (rippleRef.current) {
                rippleRef.current.cancel();
                rippleRef.current = null;
            }
        };
    }, [disabled, config]);
    return domRef;
}
//# sourceMappingURL=useRipple.js.map